import { render } from "./_WhoWeAre.vue?vue&type=template&id=353e55b6&scoped=true&lang=en"
import script from "./_WhoWeAre.vue?vue&type=script&lang=js"
export * from "./_WhoWeAre.vue?vue&type=script&lang=js"

import "./_WhoWeAre.vue?vue&type=style&index=0&id=353e55b6&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353e55b6"]])

export default __exports__